<template>
  <v-container class="dashboard-container">
    <v-row class="tile-grid">
      <v-col
        v-for="(tile, i) in tiles"
        :key="i"
        cols="12"
        sm="6"
        md="6"
        lg="4"
        xl="3"
        class="tile-column">
        <DashboardInfoTile :tile_data="tile" :loading="tile.loading" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DataService from '../../_services/DataService';
import DashboardInfoTile from '../components/DashboardTile/DashboardInfoTile.vue';
import {mapGetters} from 'vuex';
import Utils from '../utils.js';

export default {
  name: 'Dashboard',
  components: {
    DashboardInfoTile,
  },
  data() {
    return {
      admin: false,
      drawer: false,
      pageName: 'Dashboard',
      pageIcon: 'mdi-monitor-dashboard',
      roleName: '',
      title: '',
      form: {},
      panel: [1],
      received: [],
      tiles: [],
      companyLogo: '',
      tileNonAdmin0: {
        type: 'appointment',
        title: 'Next Appointment',
        icon: 'mdi-calendar-blank-outline',
        data: [{ 
          loading: true,
          date: '',
          time: '',
          patient: '',
          btn: '',
          page: '',
          icon2: '',
          icon3: '',
        }],
        loading: false,
      },
      tileNonAdmin1: {
        type: 'invoice',
        title: 'Pay Bill',
        icon: 'mdi-credit-card-outline',
        data: [
          {
            subject: '',
            amount: '$0.00',
            desc: '',
            desc2: 'Your account balance is',
            late: false,
            location: '',
            body: '',
            page: 'BillPay',
            loading: true,
          },
        ],
      },
      tileNonAdmin2: {
        type: 'forms',
        title: 'Forms',
        icon: 'mdi-file-document-outline',
        data: [{
          loading: true,
          btn: 'View Forms',
          action: () => {
            this.$router.push({
              name: 'Account',
              query: { tab: 'forms' },
            });
          },
        }],
      },
      tileNonAdmin3: {
        type: 'treatmentplan',
        title: 'Treatment Plan',
        icon: 'mdi-notebook-outline',
        data: [{
          loading: false,
          btn: 'View Plan',
          alert: 'You have pending treatment planned, you may schedule an appointment',
          action: () => {
            this.$router.push({
              name: 'PatientTreatmentPlans',
            });
          },
        }],
      },

    };
  },
  computed: {
    activeCols: function () {
      return this.headers.filter(function (u) {
        return u.active == 1;
      });
    },

    ...mapGetters(['getAdminDashboadTiles']),
  },
  methods: {
    async getConfigLogo() {
      const response = await DataService.getConfigLogo();
      this.companyLogo = response.data;
    },

    async setNonAdminApptTile(appointments) {
      const nextAppointment = this.findNextAppointment(appointments);
      if (nextAppointment) {
        this.mapTileAppointment(nextAppointment);
      } else {
        this.setTileNoAppointments();
      }
    },
    findNextAppointment(appointments) {
      if (!appointments || !appointments.length) {
        return undefined;
      }

      const now = new Date();
      return appointments.find((appointment) => new Date(appointment.date) > now);
    },
    setTileNoAppointments() {
      this.tiles = this.tiles.map((tile) => {
        if (tile.type === 'appointment') {
          tile.data[0] = {
            btn: 'Create New Appointment',
            icon2: 'mdi-domain',
            icon3: 'mdi-account',
            doctor: 'No appointments are currently scheduled',
            loading: false,
            page: 'PatientSchedule',
          };
          tile.loading = false;
        }
        return tile;
      });
      this.$forceUpdate();
    },
    mapTileAppointment(d) {
      this.tiles = this.tiles.map((tile) => {
        if (tile.type === 'appointment') {
          tile.data[0] = {
            icon2: 'mdi-domain',
            icon3: 'mdi-account',
            date: Utils.formatDate(d?.date),
            time: Utils.formatTime(d?.date),
            doctor: `Provider: ${d.provider.firstName} ${d.provider.lastName}`,
            patient: `Patient: ${d.patient.firstName} ${d.patient.lastName}`,
            btn: 'View Upcoming Appointments',
            loading: false,
            page: 'ScheduledAppointments',
          };
          tile.loading = false;
        }
        return tile;
      });
      this.$forceUpdate();
    },
    async getTileCards() {
      if (this.roleName === 'patient') {
        this.tiles.push(
          this.tileNonAdmin0,
          this.tileNonAdmin1,
          this.tileNonAdmin2,
        );
      } else {
        this.tiles = this.$store.getters.getAdminDashboardTiles;
      }
    },
    setBalanceTile(totalBalance) {
      this.tiles = this.tiles.map((el) => {
        if (el.type == 'invoice') {
          el.data[0].amount = Utils.formatCurrency(totalBalance);
          el.data[0].loading = false;
        }
        return el;
      });
    },
    async getData() {
      if (this.roleName === 'patient') {
        const [balanceResponse, lastFormResponse, formsResponse, treatmentPlansResponse, appointmentsResponse] = await Promise.all([
          DataService.getPatientAccountBalance(),
          DataService.getLastFormForCurrentPatient(),
          DataService.getFormsForPatient(),
          DataService.getTreatmentPlansForPatient(),
          DataService.getPatientAppointments(),
        ]);

        if (balanceResponse.status === 200) {
          this.setBalanceTile(balanceResponse.data.balance);
        }

        if (lastFormResponse.status === 200) {
          const outstandingForms = lastFormResponse.data.Description !== 'Registration - 5 - Privacy Notice';
          this.tiles = this.tiles.map((el) => {
            if (el.type === 'forms') {
              if (outstandingForms) {
                el.data[0].alert = 'Pending registration forms to complete';
              }

              el.data[0].loading = false;
            }

            return el;
          });
        }

        if (formsResponse.status === 200) {
          const outstandingForms = formsResponse.data.some((form) => !form.completedAt);
          this.tiles = this.tiles.map((el) => {
            if (el.type === 'forms') {
              if (outstandingForms) {
                el.data[0].alert = 'Pending registration forms to complete';
              }

              el.data[0].loading = false;
            }

            return el;
          });
        }

        if (treatmentPlansResponse.status === 200) {
          if (treatmentPlansResponse.data.plannedAppointments.length) {
            this.tiles.push(this.tileNonAdmin3);
          }
        }

        if (appointmentsResponse.status === 200) {
          const nextAppointment = this.findNextAppointment(appointmentsResponse.data);
          this.tiles = this.tiles.map((el) => {
            if (el.type === 'appointment') {
              if (nextAppointment) {
                el.data[0].date = Utils.formatDate(nextAppointment.date);
                el.data[0].time = Utils.formatTime(nextAppointment.date);
                el.data[0].doctor = `Provider: ${nextAppointment.provider.firstName} ${nextAppointment.provider.lastName}`;
                el.data[0].patient = `Patient: ${nextAppointment.patient.firstName} ${nextAppointment.patient.lastName}`;
                el.data[0].btn = 'View Upcoming Appointments';
                el.data[0].page = 'ScheduledAppointments';
                el.data[0].loading = false;
              } else {
                el.data[0].btn = 'Create New Appointment';
                el.data[0].doctor = 'No appointments are currently scheduled';
                el.data[0].page = 'PatientSchedule';
                el.data[0].loading = false;
              }
            }
            return el;
          });
        } else {
          this.tiles = this.tiles.map((el) => {
            if (el.type === 'appointment') {
              el.data[0] = {
                btn: 'Create New Appointment',
                doctor: 'No appointments are currently scheduled',
                loading: false,
                page: 'PatientSchedule',
              };
            }
            return el;
          });
        }
      } else {
        const messageCountResponse = await DataService.getUnreadMessageCount();
        if (messageCountResponse.status === 200 && messageCountResponse.data > 0) {
          this.tiles = this.tiles.map((el) => {
            if (el.type === 'email') {
              el.data = [{
                ...el.data[0],
                alert: `There are ${messageCountResponse.data} unread sms messages`,
              }];
            }

            el.data[0].loading = false;

            return el;
          });
        }
      }
    },
  },
  created() {
    // redirect if redirectURI is found
    if (this.$route.query.redirectURI != undefined) {
      window.location.href = this.$route.query.redirectURI;
    }
  },
  async mounted() {
    this.roleName = DataService.getRole();

    await this.getConfigLogo();
    //these are called seperately so that the tiles can be rendered while data is loading
    await this.getTileCards();
    await this.getData();
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';
@import '@/scss/mixins/_mobile-nav-spacing.scss';

// Component-specific colors
$dashboard-text-color: #414a5b;

.dashboard-container {
  padding: 20px 20px 0px 20px !important;

  .tile-grid {
    gap: 16px;
    
    @include mobile-nav-spacing;
  }

  .tile-column {
    padding: 8px;
  }

  .welcomeText {
    color: $dashboard-text-color;
    font-size: 25px;
    font-weight: 700;
  }
}
</style>
